import '@rentacenter/racstrap/dist/index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory, History } from 'history';

import { App } from './components/app/App';

import './index.scss';

window.renderReports = (containerId: string, history: History) => {
  const elem = document.getElementById(containerId);

  if (elem) {
    ReactDOM.render(<App history={history} />, elem);
  }
};

window.unmountReports = (containerId: string) => {
  const elem = document.getElementById(containerId);

  if (elem) {
    ReactDOM.unmountComponentAtNode(elem);
  }
};

if (!window.isRenderedByContainer) {
  import('./bootstrap').then(() => {
    const defaultHistory = createBrowserHistory({
      basename: process.env.PUBLIC_URL
    });

    window.renderReports('root', defaultHistory);
  });
}
